import React, { useEffect, useState } from "react";
import { useFieldEditorData, usePlaybackData, useDrillViewData, usePerformerManipulationData } from "../hooks/useFieldEditorShared.tsx";

export default function FieldEditorContextPopup() {
    const { drill } = useDrillViewData();
    const {
        playbackState,
        setPlaybackState,
        handlePageChange,
        handleCountChange,
        handlePlayDrill,
        handleStopDrill,
    } = usePlaybackData();
    const { fieldEditorData } = useFieldEditorData();
    const { applyEvenSpacing } = usePerformerManipulationData();
    const [showPopup, setShowPopup] = useState(false);
    const [selectedPerformers, setSelectedPerformers] = useState([]);
    const [spacing, setSpacing] = useState(2);
    const [numSelectedPerformers, setNumSelectedPerformers] = useState(0);
    useEffect(() => {
        if (drill && drill?.engine?.selectedPerformers && drill?.engine?.selectedPerformers.length > 0) {
            setShowPopup(true);
            setNumSelectedPerformers(drill?.engine?.selectedPerformers.length);
        }
        else {
            setShowPopup(false);

            setNumSelectedPerformers(0);
        }
    }, [drill?.engine?.selectedPerformers]);
    return (
        <>
            {showPopup && (
                <div className="absolute bottom-20 z-50 left-1/2 transform -translate-x-1/2 bg-white rounded-lg shadow-lg p-3 flex items-center space-x-3">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="text-gray-500"
                    >
                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                        <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                        <line x1="12" y1="22.08" x2="12" y2="12"></line>
                    </svg>
                    <div>
                        <label
                            htmlFor="spacing"
                            className="block text-xs font-medium text-gray-700"
                        >
                            Spacing (steps)
                        </label>
                        <input
                            type="number"
                            id="spacing"
                            min={1}
                            max={20}
                            defaultValue={2}
                            onChange={(e) =>
                                applyEvenSpacing(Number(e.target.value))
                            }
                            className="mt-1 w-20 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm"
                        />
                    </div>
                    <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-md">
                        {numSelectedPerformers} selected
                    </span>

                </div >
            )}
        </>
    );
}